(ns hai.mini-apps.icons
  (:require
   [hai.ui.icons :as icons]))

(def tool->icon
  "Maps a `:mini-app/tool` (or `:connection/type`) keyword to its icon component."
  {:airtable        icons/airtable
   :notion          icons/notion
   :hubspot         icons/hubspot
   :jdbc            icons/database-generic
   :database        icons/database-generic
   :notes           icons/humble-note
   :tasks           icons/humble-task
   :contacts        icons/outlined-people
   :calendar        icons/calendar
   :progress        (icons/mui-icon :outlined :timeline)
   :tips-and-tricks (icons/mui-icon :outlined :lightbulb)})
